import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21d1e0e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "py-2" }, "Företag jag inte kan företräda", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "maxWidthConstrained" }, " Vi kan se att du har en roll i ett eller flera företag. För att du ska kunna se uppgifter och ärenden så behöver du som inte är firmatecknare bli tilldelad en fullmakt som ombud. Kontakta firmatecknaren för det företag som du vill representera och be denne anmäla fullmakt för dig i tjänsten Mina Ombud. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "py-2" }, "Organisationsnummer och namn", -1))

import { useAuthStore } from '@/stores/authStore'
import selectionCard from '@/components/ui/selection-card.vue'
import { watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'companies-withOutAccess',
  setup(__props) {

const AuthStore = useAuthStore()

const nonSignerCompanies = AuthStore.getOtherCompanies

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nonSignerCompanies), (company) => {
      return (_openBlock(), _createElementBlock("div", {
        key: company.organisationNumber
      }, [
        _createVNode(selectionCard, {
          object: company,
          "first-row": ['organisationNumber', 'name'],
          disabled: true
        }, null, 8, ["object"])
      ]))
    }), 128))
  ]))
}
}

})